import { gql } from '@apollo/client';

/**
 * The owner's response sets a form references, as the fill elements read
 * them. Omits the tenant id the authenticated fragment carries.
 */
export const PUBLIC_RESPONSE_SET_FIELDS = gql`
  fragment PublicResponseSetFields on DocumentResponseSet {
    id
    name
    type
    allowOther
    allowNone
    isScoring
    responses {
      name
      colour
      score
      flagged
    }
    columns {
      key
      name
      showInDropdown
      showColumnNameInDropdown
    }
    tableRows {
      id
      values
    }
    scoreColumnKey
    flaggedColumnKey
    maxScoreOverride
    labelColumnKey
    valueColumnKey
    allowUserEntry
    userEntryFlagged
    userEntryScore
    userEntryValue
  }
`;

export const PUBLIC_FORM_QUERY = gql`
  ${PUBLIC_RESPONSE_SET_FIELDS}
  query publicForm($publicSlug: String!, $password: String) {
    publicForm(publicSlug: $publicSlug, password: $password) {
      publicSlug
      name
      requirePassword
      passwordValid
      updatedAt
      versionId
      versionNumber
      content
      responseSets {
        ...PublicResponseSetFields
      }
      requireTurnstile
      requiredOverride
      answerableTypeIds
      availability
      publicStartAt
      publicExpiryAt
      publicTimezone
    }
  }
`;
